import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import { MatRadioChange } from '@angular/material/radio';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {take} from 'rxjs/operators';

@Component({
  selector: 'app-addnewcompany',
  templateUrl: './addnewcompany.component.html',
  styleUrls: ['./addnewcompany.component.css']
})
export class AddnewcompanyComponent implements OnInit {

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) { }

  Company: {[k: string]: any} = {};
  Country: {[k: string]: any} = {};
  Address: {[k: string]: any} = {};
  UnValidCompany:boolean;
  UnValidAddress:boolean;

  ShowStepOne:boolean;
  ShowStepTwo:boolean;

  ngOnInit(): void {
    this.UnValidCompany = true;
    this.UnValidAddress = true;
    this.Country = null;
    this.ShowStepOne = true;
    this.ShowStepTwo = false;
  }

  TestCompanyValidity(){
    if(this.Country != null && this.Company.VATNumber?.length > 0 && this.Company.Name?.length > 0){
      this.UnValidCompany = false;
    }
    else{
      this.UnValidCompany = true;
    }
  }

  TestCompanyAddressValidity(){
    if(this.Address.StateProvince?.length > 0 && this.Address.City?.length > 0 && this.Address.AddressLine?.length > 0){
      this.UnValidAddress = false;
    }
    else{
      this.UnValidAddress = true;
    }
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

GetCompany(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Company:this.Company,
    Country:this.Country
  };

  this.parent.loading = true;

  this.service.GetCompany(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else{
      this.ShowStepOne = false;
      this.ShowStepTwo = true;
    }
 
    this.parent.loading = false;
  });
}

AddCompany(){
   
  this.Address.Country = this.Country;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Company:this.Company,
    Country:this.Country,
    Address:this.Address
  };

  this.parent.loading = true;

  this.service.AddCompany(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShowStepOne = false;
      this.ShowStepTwo = false;
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
 
    this.parent.loading = false;
  });
}

BackToStepOne(){
  this.ShowStepOne = true;
  this.ShowStepTwo = false;
}

GetPartnerEUData(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    VAT:this.Company.VATNumber,
    CountryCode:this.Country.ShortName
  };

  this.parent.loading = true;

  this.service.GetPartnerEUData(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Company.VATNumber = response["VAT"];
      this.Company.Name = response["Name"];
      this.Company.Alias = response["Name"];
      this.Address.AddressLine = response["Address"];

      this.TestCompanyValidity();
      this.GetCompany();
      this.TestCompanyAddressValidity();
    }
    
    this.parent.loading = false;
  });
}

}
